import React from "react";
import ReactDOM from "react-dom";
import Typical from "react-typical";
import { NavLink} from "react-router-dom";
import "./index.css";

const Skill = () => {
  return (
    <>
      <section className="skills" id="skills">
        <div className="max-width">
          <h2 className="title">My Skills</h2>
          <div className="skills-content">
            <div className="column left">
              <div className="text">My <span className="typing-2">
                  <Typical
                    loop={Infinity}
                    wrapper="b"
                    steps={["Skills", 2000, "Experiences", 2000]}
                  ></Typical>
                  </span>
                </div>
              <p>
                I’m a versatile developer with a passion for creating innovative solutions across various platforms and technologies! Here’s a glimpse of what I bring to the table:
              </p>
              <br/>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li style={{ color: "white" }}><strong style={{color: "#10ecda"}}>Game and Application Development:</strong> I have hands-on experience in crafting immersive games (2D, 3D, AR & VR) and robust applications using languages like Python, Java, JavaScript, C++, and C#. My toolkit includes powerful software like Android Studio, Unity 3D, and Blender, enabling me to bring ideas to life.</li><br/>

                <li style={{ color: "white" }}><strong style={{color: "#10ecda"}}>Web Development:</strong> I thrive in the world of web development! I’m proficient in HTML, CSS, and JavaScript, with a knack for utilizing React libraries to build dynamic, responsive websites.</li><br/>

                <li style={{ color: "white" }}><strong style={{color: "#10ecda"}}>Machine Learning Enthusiast:</strong> My journey into machine learning has been exhilarating! I’ve worked on various projects, experimenting with different models to enhance their accuracy. I’ve also delved into text recognition using OCR and explored computer vision with OpenCV.</li><br/>

                <li style={{ color: "white" }}><strong style={{color: "#10ecda"}}>Full-Stack Development:</strong> I specialize in building secure, fully functional websites using Django, ensuring a robust backend experience. Additionally, I’ve developed microservices with Flask and FastAPI, deploying them effortlessly on Azure Cloud.</li><br/>

                <li style={{ color: "white" }}><strong style={{color: "#10ecda"}}>Cloud Computing & Containerization:</strong> With a solid understanding of cloud computing, Docker and Kubernetes to streamline application deployment and management.</li><br/>

                <li style={{ color: "white" }}><strong style={{color: "#10ecda"}}>Interactive Hardware Projects:</strong> My curiosity extends to the world of microcontrollers! I’ve built exciting projects integrating various sensors, utilizing Processing.js and p5.js to create engaging interactivity.</li><br/>

              </ul>
              <p>
              Each of these skills reflects my commitment to continuous learning and my passion for innovation. I’m excited to push the envelope and turn challenges into opportunities!
              </p>
              <NavLink to="/project" className="menu-btn">
                My Projects
              </NavLink>
            </div>
            <div className="column right">
              <div className="bars">
                <div className="info">
                  <span>C++</span>
                  <span>80%</span>
                </div>
                <div className="line cpp"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>Python</span>
                  <span>90%</span>
                </div>
                <div className="line py"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>Java</span>
                  <span>80%</span>
                </div>
                <div className="line java"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>JavaScript</span>
                  <span>70%</span>
                </div>
                <div className="line js"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>Azure Cloud</span>
                  <span>80%</span>
                </div>
                <div className="line az"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>SQL</span>
                  <span>80%</span>
                </div>
                <div className="line sql"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>Flask/Django</span>
                  <span>80%</span>
                </div>
                <div className="line fd"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>Unity/C#</span>
                  <span>60%</span>
                </div>
                <div className="line uc"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>Linux</span>
                  <span>80%</span>
                </div>
                <div className="line lx"></div>
              </div>
              <div className="bars">
                <div className="info">
                  <span>React</span>
                  <span>70%</span>
                </div>
                <div className="line lx"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Skill;
